import { useEffect } from 'react';
var useGTM = function useGTM() {
  var includeGTM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  useEffect(function () {
    if (includeGTM) {
      /* eslint-disable */
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', "".concat(window.SM.MetricsTracker.getConfig().gtmId));
      /* eslint-enable */
    }
  }, [includeGTM]);
};
export default useGTM;
//# sourceMappingURL=useGTM.js.map